import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[autofocus]'
})
export class AutoFocusDirective implements AfterViewInit{

  constructor(
    private elementRef: ElementRef<HTMLInputElement>
  ) { }

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.focus();
  }

}
